/* tslint:disable */
/* eslint-disable */
/**
 * Tezaury Application API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AlternativnyTermin
 */
export interface AlternativnyTermin {
    /**
     * 
     * @type {string}
     * @memberof AlternativnyTermin
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlternativnyTermin
     */
    'alternativnyTermin'?: string;
}
/**
 * 
 * @export
 * @interface AutorZmeny
 */
export interface AutorZmeny {
    /**
     * 
     * @type {string}
     * @memberof AutorZmeny
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AutorZmeny
     */
    'meno'?: string;
    /**
     * 
     * @type {string}
     * @memberof AutorZmeny
     */
    'priezvisko'?: string;
    /**
     * 
     * @type {string}
     * @memberof AutorZmeny
     */
    'celeMeno'?: string;
}
/**
 * 
 * @export
 * @interface Definicia
 */
export interface Definicia {
    /**
     * 
     * @type {string}
     * @memberof Definicia
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Definicia
     */
    'definicia'?: string;
    /**
     * 
     * @type {string}
     * @memberof Definicia
     */
    'popisLegislativnehoZdroja'?: string;
    /**
     * 
     * @type {string}
     * @memberof Definicia
     */
    'zdroj'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const OpravnenieEnum = {
    Verejnost: 'VEREJNOST',
    Pripomienkovatel: 'PRIPOMIENKOVATEL',
    Vyhodnocovatel: 'VYHODNOCOVATEL',
    Odosielatel: 'ODOSIELATEL',
    Anonymous: 'ANONYMOUS',
    Superadmin: 'SUPERADMIN',
    NelegislativnaOrganizacia: 'NELEGISLATIVNA_ORGANIZACIA',
    PredkladatelLeg: 'PREDKLADATEL_LEG',
    PredkladatelNeleg: 'PREDKLADATEL_NELEG',
    PredkladatelZodp: 'PREDKLADATEL_ZODP',
    AktyEu: 'AKTY_EU',
    AktyEuSpravca: 'AKTY_EU_SPRAVCA',
    Clen: 'CLEN',
    SchvalovatelVlada: 'SCHVALOVATEL_VLADA',
    Spracovatel: 'SPRACOVATEL',
    VeduciOrganizacie: 'VEDUCI_ORGANIZACIE',
    VyhlasovatelPortal: 'VYHLASOVATEL_PORTAL',
    RezortneZbierkyImport: 'REZORTNE_ZBIERKY_IMPORT',
    RezortneZbierkySpravca: 'REZORTNE_ZBIERKY_SPRAVCA',
    SchvalovatelTezaurus: 'SCHVALOVATEL_TEZAURUS',
    AdministratorTezaurus: 'ADMINISTRATOR_TEZAURUS',
    RedaktorTezaurus: 'REDAKTOR_TEZAURUS',
    SudneRozhodnutiaEuSpravca: 'SUDNE_ROZHODNUTIA_EU_SPRAVCA'
} as const;

export type OpravnenieEnum = typeof OpravnenieEnum[keyof typeof OpravnenieEnum];


/**
 * 
 * @export
 * @interface Page
 */
export interface Page {
    /**
     * total count of elements
     * @type {number}
     * @memberof Page
     */
    'totalElements': number;
    /**
     * current page number
     * @type {number}
     * @memberof Page
     */
    'number': number;
    /**
     * size of the page
     * @type {number}
     * @memberof Page
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface PouzitiePredpis
 */
export interface PouzitiePredpis {
    /**
     * 
     * @type {string}
     * @memberof PouzitiePredpis
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PouzitiePredpis
     */
    'popis'?: string;
    /**
     * 
     * @type {string}
     * @memberof PouzitiePredpis
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface PreviazaneTerminyUpdate
 */
export interface PreviazaneTerminyUpdate {
    /**
     * 
     * @type {Array<PreviazanyTerminUpdate>}
     * @memberof PreviazaneTerminyUpdate
     */
    'previazanyTerminList'?: Array<PreviazanyTerminUpdate>;
}
/**
 * 
 * @export
 * @interface PreviazanyTermin
 */
export interface PreviazanyTermin {
    /**
     * 
     * @type {string}
     * @memberof PreviazanyTermin
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviazanyTermin
     */
    'nazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviazanyTermin
     */
    'vztah'?: string;
    /**
     * 
     * @type {Tezaurus}
     * @memberof PreviazanyTermin
     */
    'tezaurus'?: Tezaurus;
    /**
     * 
     * @type {number}
     * @memberof PreviazanyTermin
     */
    'order'?: number;
}
/**
 * 
 * @export
 * @interface PreviazanyTerminUpdate
 */
export interface PreviazanyTerminUpdate {
    /**
     * 
     * @type {string}
     * @memberof PreviazanyTerminUpdate
     */
    'previazanyTerminUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviazanyTerminUpdate
     */
    'vztah'?: PreviazanyTerminUpdateVztahEnum;
}

export const PreviazanyTerminUpdateVztahEnum = {
    Pribuzny: 'PRIBUZNY',
    Vseobecnejsi: 'VSEOBECNEJSI',
    Konkretnejsi: 'KONKRETNEJSI'
} as const;

export type PreviazanyTerminUpdateVztahEnum = typeof PreviazanyTerminUpdateVztahEnum[keyof typeof PreviazanyTerminUpdateVztahEnum];

/**
 * 
 * @export
 * @interface PublikaciaChange
 */
export interface PublikaciaChange {
    /**
     * 
     * @type {boolean}
     * @memberof PublikaciaChange
     */
    'publikovany'?: boolean;
}
/**
 * 
 * @export
 * @interface PublikovanyTermin
 */
export interface PublikovanyTermin {
    /**
     * 
     * @type {string}
     * @memberof PublikovanyTermin
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof PublikovanyTermin
     */
    'terminUuid': string;
    /**
     * 
     * @type {string}
     * @memberof PublikovanyTermin
     */
    'termin': string;
    /**
     * 
     * @type {string}
     * @memberof PublikovanyTermin
     */
    'preferovanyTermin': string;
    /**
     * 
     * @type {string}
     * @memberof PublikovanyTermin
     */
    'tezaurus': string;
}
/**
 * 
 * @export
 * @interface PublikovanyTerminFilter
 */
export interface PublikovanyTerminFilter {
    /**
     * 
     * @type {string}
     * @memberof PublikovanyTerminFilter
     */
    'tezaurusUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublikovanyTerminFilter
     */
    'hladanyTermin'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublikovanyTerminFilter
     */
    'legalnyZdroj'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublikovanyTerminFilter
     */
    'doktrinalnyZdroj'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PublikovanyTerminFilter
     */
    'pouzitiePredpisPopisList'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PublikovanyTerminListPage
 */
export interface PublikovanyTerminListPage {
    /**
     * total count of elements
     * @type {number}
     * @memberof PublikovanyTerminListPage
     */
    'totalElements': number;
    /**
     * current page number
     * @type {number}
     * @memberof PublikovanyTerminListPage
     */
    'number': number;
    /**
     * size of the page
     * @type {number}
     * @memberof PublikovanyTerminListPage
     */
    'size': number;
    /**
     * 
     * @type {Array<PublikovanyTermin>}
     * @memberof PublikovanyTerminListPage
     */
    'terminList': Array<PublikovanyTermin>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type SortDirectionEnum = typeof SortDirectionEnum[keyof typeof SortDirectionEnum];


/**
 * 
 * @export
 * @interface Termin
 */
export interface Termin {
    /**
     * 
     * @type {string}
     * @memberof Termin
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof Termin
     */
    'termin': string;
    /**
     * 
     * @type {boolean}
     * @memberof Termin
     */
    'publikovany': boolean;
}
/**
 * 
 * @export
 * @interface TerminCreate
 */
export interface TerminCreate {
    /**
     * 
     * @type {string}
     * @memberof TerminCreate
     */
    'preferovanyTermin'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TerminCreate
     */
    'alternativnyTerminList': Array<string>;
}
/**
 * 
 * @export
 * @interface TerminDetail
 */
export interface TerminDetail {
    /**
     * 
     * @type {string}
     * @memberof TerminDetail
     */
    'uuid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TerminDetail
     */
    'publikovany'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TerminDetail
     */
    'preferovanyTermin'?: string;
    /**
     * 
     * @type {Array<AlternativnyTermin>}
     * @memberof TerminDetail
     */
    'alternativnyTerminList'?: Array<AlternativnyTermin>;
    /**
     * 
     * @type {Tezaurus}
     * @memberof TerminDetail
     */
    'tezaurus'?: Tezaurus;
    /**
     * 
     * @type {string}
     * @memberof TerminDetail
     */
    'datumPoslednejZmeny'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerminDetail
     */
    'poznamka'?: string;
    /**
     * 
     * @type {Array<Definicia>}
     * @memberof TerminDetail
     */
    'legalneDefinicieList'?: Array<Definicia>;
    /**
     * 
     * @type {Array<Definicia>}
     * @memberof TerminDetail
     */
    'doktrinalneDefinicieList'?: Array<Definicia>;
    /**
     * 
     * @type {Array<ZaznamSekcie>}
     * @memberof TerminDetail
     */
    'judikatSkList'?: Array<ZaznamSekcie>;
    /**
     * 
     * @type {Array<ZaznamSekcie>}
     * @memberof TerminDetail
     */
    'judikatEuList'?: Array<ZaznamSekcie>;
    /**
     * 
     * @type {Array<ZaznamSekcie>}
     * @memberof TerminDetail
     */
    'rozhodnutiaSkSudyList'?: Array<ZaznamSekcie>;
    /**
     * 
     * @type {Array<ZaznamSekcie>}
     * @memberof TerminDetail
     */
    'rozhodnutiaEuSudyList'?: Array<ZaznamSekcie>;
    /**
     * 
     * @type {Array<ZaznamSekcie>}
     * @memberof TerminDetail
     */
    'pravoEuList'?: Array<ZaznamSekcie>;
    /**
     * 
     * @type {Array<ZaznamSekcie>}
     * @memberof TerminDetail
     */
    'euroVocList'?: Array<ZaznamSekcie>;
    /**
     * 
     * @type {Array<PouzitiePredpis>}
     * @memberof TerminDetail
     */
    'pouzitiePredpisList'?: Array<PouzitiePredpis>;
    /**
     * 
     * @type {Array<PreviazanyTermin>}
     * @memberof TerminDetail
     */
    'previazanyTerminList'?: Array<PreviazanyTermin>;
}
/**
 * 
 * @export
 * @interface TerminHistoriaZmien
 */
export interface TerminHistoriaZmien {
    /**
     * 
     * @type {string}
     * @memberof TerminHistoriaZmien
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerminHistoriaZmien
     */
    'datum'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerminHistoriaZmien
     */
    'autor'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerminHistoriaZmien
     */
    'typ'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerminHistoriaZmien
     */
    'oblast'?: string;
}
/**
 * 
 * @export
 * @interface TerminHistoriaZmienPage
 */
export interface TerminHistoriaZmienPage {
    /**
     * total count of elements
     * @type {number}
     * @memberof TerminHistoriaZmienPage
     */
    'totalElements': number;
    /**
     * current page number
     * @type {number}
     * @memberof TerminHistoriaZmienPage
     */
    'number': number;
    /**
     * size of the page
     * @type {number}
     * @memberof TerminHistoriaZmienPage
     */
    'size': number;
    /**
     * 
     * @type {Array<TerminHistoriaZmien>}
     * @memberof TerminHistoriaZmienPage
     */
    'historiaZmienList'?: Array<TerminHistoriaZmien>;
    /**
     * 
     * @type {string}
     * @memberof TerminHistoriaZmienPage
     */
    'terminNazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerminHistoriaZmienPage
     */
    'tezaurusNazov'?: string;
}
/**
 * 
 * @export
 * @interface TerminLegalneDefinicieUpdate
 */
export interface TerminLegalneDefinicieUpdate {
    /**
     * 
     * @type {Array<Definicia>}
     * @memberof TerminLegalneDefinicieUpdate
     */
    'legalnaDefiniciaList'?: Array<Definicia>;
}
/**
 * 
 * @export
 * @interface TerminListPage
 */
export interface TerminListPage {
    /**
     * total count of elements
     * @type {number}
     * @memberof TerminListPage
     */
    'totalElements': number;
    /**
     * current page number
     * @type {number}
     * @memberof TerminListPage
     */
    'number': number;
    /**
     * size of the page
     * @type {number}
     * @memberof TerminListPage
     */
    'size': number;
    /**
     * 
     * @type {Array<Termin>}
     * @memberof TerminListPage
     */
    'terminList': Array<Termin>;
    /**
     * 
     * @type {string}
     * @memberof TerminListPage
     */
    'tezaurus': string;
}
/**
 * 
 * @export
 * @interface TerminUpdate
 */
export interface TerminUpdate {
    /**
     * 
     * @type {string}
     * @memberof TerminUpdate
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof TerminUpdate
     */
    'preferovanyTermin'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TerminUpdate
     */
    'alternativnyTerminList': Array<string>;
}
/**
 * 
 * @export
 * @interface Tezaurus
 */
export interface Tezaurus {
    /**
     * 
     * @type {string}
     * @memberof Tezaurus
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof Tezaurus
     */
    'nazov': string;
}
/**
 * 
 * @export
 * @interface TezaurusCreate
 */
export interface TezaurusCreate {
    /**
     * 
     * @type {string}
     * @memberof TezaurusCreate
     */
    'nazov': string;
}
/**
 * 
 * @export
 * @interface TezaurusList
 */
export interface TezaurusList {
    /**
     * 
     * @type {Array<Tezaurus>}
     * @memberof TezaurusList
     */
    'tezaurusList': Array<Tezaurus>;
}
/**
 * 
 * @export
 * @interface TezaurusTerminPair
 */
export interface TezaurusTerminPair {
    /**
     * 
     * @type {string}
     * @memberof TezaurusTerminPair
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof TezaurusTerminPair
     */
    'nazov': string;
    /**
     * 
     * @type {string}
     * @memberof TezaurusTerminPair
     */
    'termin': string;
    /**
     * 
     * @type {boolean}
     * @memberof TezaurusTerminPair
     */
    'publikovany': boolean;
}
/**
 * 
 * @export
 * @interface UpdateTerminPoznamkaRequest
 */
export interface UpdateTerminPoznamkaRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateTerminPoznamkaRequest
     */
    'poznamka'?: string;
}
/**
 * 
 * @export
 * @interface UserDetail
 */
export interface UserDetail {
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'meno'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'organizaciaUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'organizaciaNazov'?: string;
    /**
     * 
     * @type {Array<OpravnenieEnum>}
     * @memberof UserDetail
     */
    'opravnenieList'?: Array<OpravnenieEnum>;
}
/**
 * 
 * @export
 * @interface ZaznamSekcie
 */
export interface ZaznamSekcie {
    /**
     * 
     * @type {string}
     * @memberof ZaznamSekcie
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ZaznamSekcie
     */
    'nazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof ZaznamSekcie
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof ZaznamSekcie
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof ZaznamSekcie
     */
    'typ'?: ZaznamSekcieTypEnum;
}

export const ZaznamSekcieTypEnum = {
    JudikatSk: 'JUDIKAT_SK',
    JudikatEu: 'JUDIKAT_EU',
    RozhodnutieSkSudu: 'ROZHODNUTIE_SK_SUDU',
    RozhodnutieEuSudu: 'ROZHODNUTIE_EU_SUDU',
    PravoEu: 'PRAVO_EU',
    Eurovoc: 'EUROVOC'
} as const;

export type ZaznamSekcieTypEnum = typeof ZaznamSekcieTypEnum[keyof typeof ZaznamSekcieTypEnum];


/**
 * AutorZmenyListApi - axios parameter creator
 * @export
 */
export const AutorZmenyListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get possible autor zmeny list
         * @param {string} [tezaurusUuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutorZmenyList: async (tezaurusUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/terminy/autori-zmien`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (tezaurusUuid !== undefined) {
                localVarQueryParameter['tezaurusUuid'] = tezaurusUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AutorZmenyListApi - functional programming interface
 * @export
 */
export const AutorZmenyListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AutorZmenyListApiAxiosParamCreator(configuration)
    return {
        /**
         * Get possible autor zmeny list
         * @param {string} [tezaurusUuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAutorZmenyList(tezaurusUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AutorZmeny>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAutorZmenyList(tezaurusUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutorZmenyListApi.getAutorZmenyList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AutorZmenyListApi - factory interface
 * @export
 */
export const AutorZmenyListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AutorZmenyListApiFp(configuration)
    return {
        /**
         * Get possible autor zmeny list
         * @param {string} [tezaurusUuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutorZmenyList(tezaurusUuid?: string, options?: any): AxiosPromise<Array<AutorZmeny>> {
            return localVarFp.getAutorZmenyList(tezaurusUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AutorZmenyListApi - object-oriented interface
 * @export
 * @class AutorZmenyListApi
 * @extends {BaseAPI}
 */
export class AutorZmenyListApi extends BaseAPI {
    /**
     * Get possible autor zmeny list
     * @param {string} [tezaurusUuid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutorZmenyListApi
     */
    public getAutorZmenyList(tezaurusUuid?: string, options?: RawAxiosRequestConfig) {
        return AutorZmenyListApiFp(this.configuration).getAutorZmenyList(tezaurusUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExportTerminovApi - axios parameter creator
 * @export
 */
export const ExportTerminovApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Export list of termin in pdf.
         * @param {string} [tezaurusUuid] 
         * @param {string} [hladanyTermin] 
         * @param {string} [legalnyZdroj] 
         * @param {string} [doktrinalnyZdroj] 
         * @param {Array<string>} [pouzitiePredpisPopisList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportOfTerminList: async (tezaurusUuid?: string, hladanyTermin?: string, legalnyZdroj?: string, doktrinalnyZdroj?: string, pouzitiePredpisPopisList?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/exporty/terminy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (tezaurusUuid !== undefined) {
                localVarQueryParameter['tezaurusUuid'] = tezaurusUuid;
            }

            if (hladanyTermin !== undefined) {
                localVarQueryParameter['hladanyTermin'] = hladanyTermin;
            }

            if (legalnyZdroj !== undefined) {
                localVarQueryParameter['legalnyZdroj'] = legalnyZdroj;
            }

            if (doktrinalnyZdroj !== undefined) {
                localVarQueryParameter['doktrinalnyZdroj'] = doktrinalnyZdroj;
            }

            if (pouzitiePredpisPopisList) {
                localVarQueryParameter['pouzitiePredpisPopisList'] = pouzitiePredpisPopisList;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export list of termin in pdf - admin.
         * @param {string} [tezaurusUuid] 
         * @param {string} [hladanyTermin] 
         * @param {boolean} [publikovany] 
         * @param {string} [autorPoslednejZmeny] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportOfTerminListAdmin: async (tezaurusUuid?: string, hladanyTermin?: string, publikovany?: boolean, autorPoslednejZmeny?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/exporty/terminy-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (tezaurusUuid !== undefined) {
                localVarQueryParameter['tezaurusUuid'] = tezaurusUuid;
            }

            if (hladanyTermin !== undefined) {
                localVarQueryParameter['hladanyTermin'] = hladanyTermin;
            }

            if (publikovany !== undefined) {
                localVarQueryParameter['publikovany'] = publikovany;
            }

            if (autorPoslednejZmeny !== undefined) {
                localVarQueryParameter['autorPoslednejZmeny'] = autorPoslednejZmeny;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExportTerminovApi - functional programming interface
 * @export
 */
export const ExportTerminovApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExportTerminovApiAxiosParamCreator(configuration)
    return {
        /**
         * Export list of termin in pdf.
         * @param {string} [tezaurusUuid] 
         * @param {string} [hladanyTermin] 
         * @param {string} [legalnyZdroj] 
         * @param {string} [doktrinalnyZdroj] 
         * @param {Array<string>} [pouzitiePredpisPopisList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExportOfTerminList(tezaurusUuid?: string, hladanyTermin?: string, legalnyZdroj?: string, doktrinalnyZdroj?: string, pouzitiePredpisPopisList?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExportOfTerminList(tezaurusUuid, hladanyTermin, legalnyZdroj, doktrinalnyZdroj, pouzitiePredpisPopisList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportTerminovApi.getExportOfTerminList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export list of termin in pdf - admin.
         * @param {string} [tezaurusUuid] 
         * @param {string} [hladanyTermin] 
         * @param {boolean} [publikovany] 
         * @param {string} [autorPoslednejZmeny] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExportOfTerminListAdmin(tezaurusUuid?: string, hladanyTermin?: string, publikovany?: boolean, autorPoslednejZmeny?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExportOfTerminListAdmin(tezaurusUuid, hladanyTermin, publikovany, autorPoslednejZmeny, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportTerminovApi.getExportOfTerminListAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExportTerminovApi - factory interface
 * @export
 */
export const ExportTerminovApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExportTerminovApiFp(configuration)
    return {
        /**
         * Export list of termin in pdf.
         * @param {string} [tezaurusUuid] 
         * @param {string} [hladanyTermin] 
         * @param {string} [legalnyZdroj] 
         * @param {string} [doktrinalnyZdroj] 
         * @param {Array<string>} [pouzitiePredpisPopisList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportOfTerminList(tezaurusUuid?: string, hladanyTermin?: string, legalnyZdroj?: string, doktrinalnyZdroj?: string, pouzitiePredpisPopisList?: Array<string>, options?: any): AxiosPromise<string> {
            return localVarFp.getExportOfTerminList(tezaurusUuid, hladanyTermin, legalnyZdroj, doktrinalnyZdroj, pouzitiePredpisPopisList, options).then((request) => request(axios, basePath));
        },
        /**
         * Export list of termin in pdf - admin.
         * @param {string} [tezaurusUuid] 
         * @param {string} [hladanyTermin] 
         * @param {boolean} [publikovany] 
         * @param {string} [autorPoslednejZmeny] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportOfTerminListAdmin(tezaurusUuid?: string, hladanyTermin?: string, publikovany?: boolean, autorPoslednejZmeny?: string, options?: any): AxiosPromise<string> {
            return localVarFp.getExportOfTerminListAdmin(tezaurusUuid, hladanyTermin, publikovany, autorPoslednejZmeny, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExportTerminovApi - object-oriented interface
 * @export
 * @class ExportTerminovApi
 * @extends {BaseAPI}
 */
export class ExportTerminovApi extends BaseAPI {
    /**
     * Export list of termin in pdf.
     * @param {string} [tezaurusUuid] 
     * @param {string} [hladanyTermin] 
     * @param {string} [legalnyZdroj] 
     * @param {string} [doktrinalnyZdroj] 
     * @param {Array<string>} [pouzitiePredpisPopisList] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportTerminovApi
     */
    public getExportOfTerminList(tezaurusUuid?: string, hladanyTermin?: string, legalnyZdroj?: string, doktrinalnyZdroj?: string, pouzitiePredpisPopisList?: Array<string>, options?: RawAxiosRequestConfig) {
        return ExportTerminovApiFp(this.configuration).getExportOfTerminList(tezaurusUuid, hladanyTermin, legalnyZdroj, doktrinalnyZdroj, pouzitiePredpisPopisList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export list of termin in pdf - admin.
     * @param {string} [tezaurusUuid] 
     * @param {string} [hladanyTermin] 
     * @param {boolean} [publikovany] 
     * @param {string} [autorPoslednejZmeny] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportTerminovApi
     */
    public getExportOfTerminListAdmin(tezaurusUuid?: string, hladanyTermin?: string, publikovany?: boolean, autorPoslednejZmeny?: string, options?: RawAxiosRequestConfig) {
        return ExportTerminovApiFp(this.configuration).getExportOfTerminListAdmin(tezaurusUuid, hladanyTermin, publikovany, autorPoslednejZmeny, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExportTerminuApi - axios parameter creator
 * @export
 */
export const ExportTerminuApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Export terminu v pdf.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerminInPdf: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getTerminInPdf', 'uuid', uuid)
            const localVarPath = `/exporty/terminy/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export terminu v pdf.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerminInPdfAdmin: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getTerminInPdfAdmin', 'uuid', uuid)
            const localVarPath = `/exporty/terminy-admin/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExportTerminuApi - functional programming interface
 * @export
 */
export const ExportTerminuApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExportTerminuApiAxiosParamCreator(configuration)
    return {
        /**
         * Export terminu v pdf.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerminInPdf(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerminInPdf(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportTerminuApi.getTerminInPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export terminu v pdf.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerminInPdfAdmin(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerminInPdfAdmin(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportTerminuApi.getTerminInPdfAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExportTerminuApi - factory interface
 * @export
 */
export const ExportTerminuApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExportTerminuApiFp(configuration)
    return {
        /**
         * Export terminu v pdf.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerminInPdf(uuid: string, options?: any): AxiosPromise<string> {
            return localVarFp.getTerminInPdf(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Export terminu v pdf.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerminInPdfAdmin(uuid: string, options?: any): AxiosPromise<string> {
            return localVarFp.getTerminInPdfAdmin(uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExportTerminuApi - object-oriented interface
 * @export
 * @class ExportTerminuApi
 * @extends {BaseAPI}
 */
export class ExportTerminuApi extends BaseAPI {
    /**
     * Export terminu v pdf.
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportTerminuApi
     */
    public getTerminInPdf(uuid: string, options?: RawAxiosRequestConfig) {
        return ExportTerminuApiFp(this.configuration).getTerminInPdf(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export terminu v pdf.
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportTerminuApi
     */
    public getTerminInPdfAdmin(uuid: string, options?: RawAxiosRequestConfig) {
        return ExportTerminuApiFp(this.configuration).getTerminInPdfAdmin(uuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PouzitiePredpisListApi - axios parameter creator
 * @export
 */
export const PouzitiePredpisListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List of pouzite v pravnych predpisoch.
         * @param {string} [searchText] 
         * @param {Array<string>} [ids] One or more ids.
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPouzitiePredpisList: async (searchText?: string, ids?: Array<string>, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pouzite-v-pravnych-predpisoch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PouzitiePredpisListApi - functional programming interface
 * @export
 */
export const PouzitiePredpisListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PouzitiePredpisListApiAxiosParamCreator(configuration)
    return {
        /**
         * List of pouzite v pravnych predpisoch.
         * @param {string} [searchText] 
         * @param {Array<string>} [ids] One or more ids.
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPouzitiePredpisList(searchText?: string, ids?: Array<string>, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PouzitiePredpis>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPouzitiePredpisList(searchText, ids, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PouzitiePredpisListApi.getPouzitiePredpisList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PouzitiePredpisListApi - factory interface
 * @export
 */
export const PouzitiePredpisListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PouzitiePredpisListApiFp(configuration)
    return {
        /**
         * List of pouzite v pravnych predpisoch.
         * @param {string} [searchText] 
         * @param {Array<string>} [ids] One or more ids.
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPouzitiePredpisList(searchText?: string, ids?: Array<string>, limit?: number, options?: any): AxiosPromise<Array<PouzitiePredpis>> {
            return localVarFp.getPouzitiePredpisList(searchText, ids, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PouzitiePredpisListApi - object-oriented interface
 * @export
 * @class PouzitiePredpisListApi
 * @extends {BaseAPI}
 */
export class PouzitiePredpisListApi extends BaseAPI {
    /**
     * List of pouzite v pravnych predpisoch.
     * @param {string} [searchText] 
     * @param {Array<string>} [ids] One or more ids.
     * @param {number} [limit] max number of results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PouzitiePredpisListApi
     */
    public getPouzitiePredpisList(searchText?: string, ids?: Array<string>, limit?: number, options?: RawAxiosRequestConfig) {
        return PouzitiePredpisListApiFp(this.configuration).getPouzitiePredpisList(searchText, ids, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PublikaciaChangeApi - axios parameter creator
 * @export
 */
export const PublikaciaChangeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Change publikacia of termin.
         * @param {string} uuid Primary key of entity
         * @param {PublikaciaChange} publikaciaChange 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePublikacia: async (uuid: string, publikaciaChange: PublikaciaChange, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('changePublikacia', 'uuid', uuid)
            // verify required parameter 'publikaciaChange' is not null or undefined
            assertParamExists('changePublikacia', 'publikaciaChange', publikaciaChange)
            const localVarPath = `/tezaury/terminy/{uuid}/zmena-publikacie`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publikaciaChange, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublikaciaChangeApi - functional programming interface
 * @export
 */
export const PublikaciaChangeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublikaciaChangeApiAxiosParamCreator(configuration)
    return {
        /**
         * Change publikacia of termin.
         * @param {string} uuid Primary key of entity
         * @param {PublikaciaChange} publikaciaChange 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePublikacia(uuid: string, publikaciaChange: PublikaciaChange, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePublikacia(uuid, publikaciaChange, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublikaciaChangeApi.changePublikacia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PublikaciaChangeApi - factory interface
 * @export
 */
export const PublikaciaChangeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublikaciaChangeApiFp(configuration)
    return {
        /**
         * Change publikacia of termin.
         * @param {string} uuid Primary key of entity
         * @param {PublikaciaChange} publikaciaChange 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePublikacia(uuid: string, publikaciaChange: PublikaciaChange, options?: any): AxiosPromise<void> {
            return localVarFp.changePublikacia(uuid, publikaciaChange, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublikaciaChangeApi - object-oriented interface
 * @export
 * @class PublikaciaChangeApi
 * @extends {BaseAPI}
 */
export class PublikaciaChangeApi extends BaseAPI {
    /**
     * Change publikacia of termin.
     * @param {string} uuid Primary key of entity
     * @param {PublikaciaChange} publikaciaChange 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublikaciaChangeApi
     */
    public changePublikacia(uuid: string, publikaciaChange: PublikaciaChange, options?: RawAxiosRequestConfig) {
        return PublikaciaChangeApiFp(this.configuration).changePublikacia(uuid, publikaciaChange, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PublikovanyTerminListApi - axios parameter creator
 * @export
 */
export const PublikovanyTerminListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List of publikovanyTermin.
         * @param {PublikovanyTerminFilter} publikovanyTerminFilter 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublikovanyTerminList: async (publikovanyTerminFilter: PublikovanyTerminFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publikovanyTerminFilter' is not null or undefined
            assertParamExists('getPublikovanyTerminList', 'publikovanyTerminFilter', publikovanyTerminFilter)
            const localVarPath = `/publikovaneTerminy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publikovanyTerminFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublikovanyTerminListApi - functional programming interface
 * @export
 */
export const PublikovanyTerminListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublikovanyTerminListApiAxiosParamCreator(configuration)
    return {
        /**
         * List of publikovanyTermin.
         * @param {PublikovanyTerminFilter} publikovanyTerminFilter 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublikovanyTerminList(publikovanyTerminFilter: PublikovanyTerminFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublikovanyTerminListPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublikovanyTerminList(publikovanyTerminFilter, page, size, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublikovanyTerminListApi.getPublikovanyTerminList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PublikovanyTerminListApi - factory interface
 * @export
 */
export const PublikovanyTerminListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublikovanyTerminListApiFp(configuration)
    return {
        /**
         * List of publikovanyTermin.
         * @param {PublikovanyTerminFilter} publikovanyTerminFilter 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublikovanyTerminList(publikovanyTerminFilter: PublikovanyTerminFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: any): AxiosPromise<PublikovanyTerminListPage> {
            return localVarFp.getPublikovanyTerminList(publikovanyTerminFilter, page, size, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublikovanyTerminListApi - object-oriented interface
 * @export
 * @class PublikovanyTerminListApi
 * @extends {BaseAPI}
 */
export class PublikovanyTerminListApi extends BaseAPI {
    /**
     * List of publikovanyTermin.
     * @param {PublikovanyTerminFilter} publikovanyTerminFilter 
     * @param {number} [page] Page number to return, indexed from one.
     * @param {number} [size] Size of page to return.
     * @param {string} [sortBy] 
     * @param {SortDirectionEnum} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublikovanyTerminListApi
     */
    public getPublikovanyTerminList(publikovanyTerminFilter: PublikovanyTerminFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig) {
        return PublikovanyTerminListApiFp(this.configuration).getPublikovanyTerminList(publikovanyTerminFilter, page, size, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TerminCreateApi - axios parameter creator
 * @export
 */
export const TerminCreateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create new termin of selected tezaurus.
         * @param {string} uuid Primary key of entity
         * @param {TerminCreate} terminCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTermin: async (uuid: string, terminCreate: TerminCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('createTermin', 'uuid', uuid)
            // verify required parameter 'terminCreate' is not null or undefined
            assertParamExists('createTermin', 'terminCreate', terminCreate)
            const localVarPath = `/tezaury/{uuid}/terminy`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(terminCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerminCreateApi - functional programming interface
 * @export
 */
export const TerminCreateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerminCreateApiAxiosParamCreator(configuration)
    return {
        /**
         * Create new termin of selected tezaurus.
         * @param {string} uuid Primary key of entity
         * @param {TerminCreate} terminCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTermin(uuid: string, terminCreate: TerminCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTermin(uuid, terminCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TerminCreateApi.createTermin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TerminCreateApi - factory interface
 * @export
 */
export const TerminCreateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerminCreateApiFp(configuration)
    return {
        /**
         * Create new termin of selected tezaurus.
         * @param {string} uuid Primary key of entity
         * @param {TerminCreate} terminCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTermin(uuid: string, terminCreate: TerminCreate, options?: any): AxiosPromise<string> {
            return localVarFp.createTermin(uuid, terminCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TerminCreateApi - object-oriented interface
 * @export
 * @class TerminCreateApi
 * @extends {BaseAPI}
 */
export class TerminCreateApi extends BaseAPI {
    /**
     * Create new termin of selected tezaurus.
     * @param {string} uuid Primary key of entity
     * @param {TerminCreate} terminCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminCreateApi
     */
    public createTermin(uuid: string, terminCreate: TerminCreate, options?: RawAxiosRequestConfig) {
        return TerminCreateApiFp(this.configuration).createTermin(uuid, terminCreate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TerminDeleteApi - axios parameter creator
 * @export
 */
export const TerminDeleteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete termin.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTermin: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('deleteTermin', 'uuid', uuid)
            const localVarPath = `/tezaury/terminy/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerminDeleteApi - functional programming interface
 * @export
 */
export const TerminDeleteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerminDeleteApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete termin.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTermin(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTermin(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TerminDeleteApi.deleteTermin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TerminDeleteApi - factory interface
 * @export
 */
export const TerminDeleteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerminDeleteApiFp(configuration)
    return {
        /**
         * Delete termin.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTermin(uuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTermin(uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TerminDeleteApi - object-oriented interface
 * @export
 * @class TerminDeleteApi
 * @extends {BaseAPI}
 */
export class TerminDeleteApi extends BaseAPI {
    /**
     * Delete termin.
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminDeleteApi
     */
    public deleteTermin(uuid: string, options?: RawAxiosRequestConfig) {
        return TerminDeleteApiFp(this.configuration).deleteTermin(uuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TerminDetailApi - axios parameter creator
 * @export
 */
export const TerminDetailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Detail of Termin.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerminDetail: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getTerminDetail', 'uuid', uuid)
            const localVarPath = `/tezaury/terminy/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Detail of Termin for Admin.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerminDetailAdmin: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getTerminDetailAdmin', 'uuid', uuid)
            const localVarPath = `/tezaury/terminy/admin/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerminDetailApi - functional programming interface
 * @export
 */
export const TerminDetailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerminDetailApiAxiosParamCreator(configuration)
    return {
        /**
         * Detail of Termin.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerminDetail(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerminDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerminDetail(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TerminDetailApi.getTerminDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Detail of Termin for Admin.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerminDetailAdmin(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerminDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerminDetailAdmin(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TerminDetailApi.getTerminDetailAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TerminDetailApi - factory interface
 * @export
 */
export const TerminDetailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerminDetailApiFp(configuration)
    return {
        /**
         * Detail of Termin.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerminDetail(uuid: string, options?: any): AxiosPromise<TerminDetail> {
            return localVarFp.getTerminDetail(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Detail of Termin for Admin.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerminDetailAdmin(uuid: string, options?: any): AxiosPromise<TerminDetail> {
            return localVarFp.getTerminDetailAdmin(uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TerminDetailApi - object-oriented interface
 * @export
 * @class TerminDetailApi
 * @extends {BaseAPI}
 */
export class TerminDetailApi extends BaseAPI {
    /**
     * Detail of Termin.
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminDetailApi
     */
    public getTerminDetail(uuid: string, options?: RawAxiosRequestConfig) {
        return TerminDetailApiFp(this.configuration).getTerminDetail(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Detail of Termin for Admin.
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminDetailApi
     */
    public getTerminDetailAdmin(uuid: string, options?: RawAxiosRequestConfig) {
        return TerminDetailApiFp(this.configuration).getTerminDetailAdmin(uuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TerminDoktrinalneDefinicieUpdateApi - axios parameter creator
 * @export
 */
export const TerminDoktrinalneDefinicieUpdateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update doktrinalne definicie of termin.
         * @param {string} uuid Primary key of entity
         * @param {Array<Definicia>} definicia 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerminDoktrinalneDefinicie: async (uuid: string, definicia: Array<Definicia>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateTerminDoktrinalneDefinicie', 'uuid', uuid)
            // verify required parameter 'definicia' is not null or undefined
            assertParamExists('updateTerminDoktrinalneDefinicie', 'definicia', definicia)
            const localVarPath = `/tezaury/terminy/{uuid}/doktrinalne-definicie`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(definicia, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerminDoktrinalneDefinicieUpdateApi - functional programming interface
 * @export
 */
export const TerminDoktrinalneDefinicieUpdateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerminDoktrinalneDefinicieUpdateApiAxiosParamCreator(configuration)
    return {
        /**
         * Update doktrinalne definicie of termin.
         * @param {string} uuid Primary key of entity
         * @param {Array<Definicia>} definicia 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTerminDoktrinalneDefinicie(uuid: string, definicia: Array<Definicia>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTerminDoktrinalneDefinicie(uuid, definicia, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TerminDoktrinalneDefinicieUpdateApi.updateTerminDoktrinalneDefinicie']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TerminDoktrinalneDefinicieUpdateApi - factory interface
 * @export
 */
export const TerminDoktrinalneDefinicieUpdateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerminDoktrinalneDefinicieUpdateApiFp(configuration)
    return {
        /**
         * Update doktrinalne definicie of termin.
         * @param {string} uuid Primary key of entity
         * @param {Array<Definicia>} definicia 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerminDoktrinalneDefinicie(uuid: string, definicia: Array<Definicia>, options?: any): AxiosPromise<void> {
            return localVarFp.updateTerminDoktrinalneDefinicie(uuid, definicia, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TerminDoktrinalneDefinicieUpdateApi - object-oriented interface
 * @export
 * @class TerminDoktrinalneDefinicieUpdateApi
 * @extends {BaseAPI}
 */
export class TerminDoktrinalneDefinicieUpdateApi extends BaseAPI {
    /**
     * Update doktrinalne definicie of termin.
     * @param {string} uuid Primary key of entity
     * @param {Array<Definicia>} definicia 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminDoktrinalneDefinicieUpdateApi
     */
    public updateTerminDoktrinalneDefinicie(uuid: string, definicia: Array<Definicia>, options?: RawAxiosRequestConfig) {
        return TerminDoktrinalneDefinicieUpdateApiFp(this.configuration).updateTerminDoktrinalneDefinicie(uuid, definicia, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TerminFilterListApi - axios parameter creator
 * @export
 */
export const TerminFilterListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List of valid public and not public Termin pairs by search text.
         * @param {string} [searchText] 
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerminyFilterByText: async (searchText?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tezaury/terminy/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerminFilterListApi - functional programming interface
 * @export
 */
export const TerminFilterListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerminFilterListApiAxiosParamCreator(configuration)
    return {
        /**
         * List of valid public and not public Termin pairs by search text.
         * @param {string} [searchText] 
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerminyFilterByText(searchText?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TezaurusTerminPair>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerminyFilterByText(searchText, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TerminFilterListApi.getTerminyFilterByText']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TerminFilterListApi - factory interface
 * @export
 */
export const TerminFilterListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerminFilterListApiFp(configuration)
    return {
        /**
         * List of valid public and not public Termin pairs by search text.
         * @param {string} [searchText] 
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerminyFilterByText(searchText?: string, limit?: number, options?: any): AxiosPromise<Array<TezaurusTerminPair>> {
            return localVarFp.getTerminyFilterByText(searchText, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TerminFilterListApi - object-oriented interface
 * @export
 * @class TerminFilterListApi
 * @extends {BaseAPI}
 */
export class TerminFilterListApi extends BaseAPI {
    /**
     * List of valid public and not public Termin pairs by search text.
     * @param {string} [searchText] 
     * @param {number} [limit] max number of results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminFilterListApi
     */
    public getTerminyFilterByText(searchText?: string, limit?: number, options?: RawAxiosRequestConfig) {
        return TerminFilterListApiFp(this.configuration).getTerminyFilterByText(searchText, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TerminHistoriaZmienApi - axios parameter creator
 * @export
 */
export const TerminHistoriaZmienApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Historia zmien of selected termin
         * @param {string} uuid Primary key of entity
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoriaZmien: async (uuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getHistoriaZmien', 'uuid', uuid)
            const localVarPath = `/terminy/{uuid}/historia-zmien`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerminHistoriaZmienApi - functional programming interface
 * @export
 */
export const TerminHistoriaZmienApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerminHistoriaZmienApiAxiosParamCreator(configuration)
    return {
        /**
         * Historia zmien of selected termin
         * @param {string} uuid Primary key of entity
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHistoriaZmien(uuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerminHistoriaZmienPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHistoriaZmien(uuid, page, size, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TerminHistoriaZmienApi.getHistoriaZmien']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TerminHistoriaZmienApi - factory interface
 * @export
 */
export const TerminHistoriaZmienApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerminHistoriaZmienApiFp(configuration)
    return {
        /**
         * Historia zmien of selected termin
         * @param {string} uuid Primary key of entity
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoriaZmien(uuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: any): AxiosPromise<TerminHistoriaZmienPage> {
            return localVarFp.getHistoriaZmien(uuid, page, size, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TerminHistoriaZmienApi - object-oriented interface
 * @export
 * @class TerminHistoriaZmienApi
 * @extends {BaseAPI}
 */
export class TerminHistoriaZmienApi extends BaseAPI {
    /**
     * Historia zmien of selected termin
     * @param {string} uuid Primary key of entity
     * @param {number} [page] Page number to return, indexed from one.
     * @param {number} [size] Size of page to return.
     * @param {string} [sortBy] 
     * @param {SortDirectionEnum} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminHistoriaZmienApi
     */
    public getHistoriaZmien(uuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig) {
        return TerminHistoriaZmienApiFp(this.configuration).getHistoriaZmien(uuid, page, size, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TerminLegalneDefinicieUpdateApi - axios parameter creator
 * @export
 */
export const TerminLegalneDefinicieUpdateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update legalne definicie of termin.
         * @param {string} uuid Primary key of entity
         * @param {TerminLegalneDefinicieUpdate} terminLegalneDefinicieUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerminLegalneDefinicie: async (uuid: string, terminLegalneDefinicieUpdate: TerminLegalneDefinicieUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateTerminLegalneDefinicie', 'uuid', uuid)
            // verify required parameter 'terminLegalneDefinicieUpdate' is not null or undefined
            assertParamExists('updateTerminLegalneDefinicie', 'terminLegalneDefinicieUpdate', terminLegalneDefinicieUpdate)
            const localVarPath = `/tezaury/terminy/{uuid}/legalne-definicie`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(terminLegalneDefinicieUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerminLegalneDefinicieUpdateApi - functional programming interface
 * @export
 */
export const TerminLegalneDefinicieUpdateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerminLegalneDefinicieUpdateApiAxiosParamCreator(configuration)
    return {
        /**
         * Update legalne definicie of termin.
         * @param {string} uuid Primary key of entity
         * @param {TerminLegalneDefinicieUpdate} terminLegalneDefinicieUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTerminLegalneDefinicie(uuid: string, terminLegalneDefinicieUpdate: TerminLegalneDefinicieUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTerminLegalneDefinicie(uuid, terminLegalneDefinicieUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TerminLegalneDefinicieUpdateApi.updateTerminLegalneDefinicie']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TerminLegalneDefinicieUpdateApi - factory interface
 * @export
 */
export const TerminLegalneDefinicieUpdateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerminLegalneDefinicieUpdateApiFp(configuration)
    return {
        /**
         * Update legalne definicie of termin.
         * @param {string} uuid Primary key of entity
         * @param {TerminLegalneDefinicieUpdate} terminLegalneDefinicieUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerminLegalneDefinicie(uuid: string, terminLegalneDefinicieUpdate: TerminLegalneDefinicieUpdate, options?: any): AxiosPromise<void> {
            return localVarFp.updateTerminLegalneDefinicie(uuid, terminLegalneDefinicieUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TerminLegalneDefinicieUpdateApi - object-oriented interface
 * @export
 * @class TerminLegalneDefinicieUpdateApi
 * @extends {BaseAPI}
 */
export class TerminLegalneDefinicieUpdateApi extends BaseAPI {
    /**
     * Update legalne definicie of termin.
     * @param {string} uuid Primary key of entity
     * @param {TerminLegalneDefinicieUpdate} terminLegalneDefinicieUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminLegalneDefinicieUpdateApi
     */
    public updateTerminLegalneDefinicie(uuid: string, terminLegalneDefinicieUpdate: TerminLegalneDefinicieUpdate, options?: RawAxiosRequestConfig) {
        return TerminLegalneDefinicieUpdateApiFp(this.configuration).updateTerminLegalneDefinicie(uuid, terminLegalneDefinicieUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TerminListApi - axios parameter creator
 * @export
 */
export const TerminListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List of Termin.
         * @param {string} uuid Primary key of entity
         * @param {string} [hladanyTermin] 
         * @param {boolean} [publikovany] 
         * @param {string} [autorPoslednejZmeny] 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerminList: async (uuid: string, hladanyTermin?: string, publikovany?: boolean, autorPoslednejZmeny?: string, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getTerminList', 'uuid', uuid)
            const localVarPath = `/tezaury/{uuid}/terminy`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (hladanyTermin !== undefined) {
                localVarQueryParameter['hladanyTermin'] = hladanyTermin;
            }

            if (publikovany !== undefined) {
                localVarQueryParameter['publikovany'] = publikovany;
            }

            if (autorPoslednejZmeny !== undefined) {
                localVarQueryParameter['autorPoslednejZmeny'] = autorPoslednejZmeny;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerminListApi - functional programming interface
 * @export
 */
export const TerminListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerminListApiAxiosParamCreator(configuration)
    return {
        /**
         * List of Termin.
         * @param {string} uuid Primary key of entity
         * @param {string} [hladanyTermin] 
         * @param {boolean} [publikovany] 
         * @param {string} [autorPoslednejZmeny] 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerminList(uuid: string, hladanyTermin?: string, publikovany?: boolean, autorPoslednejZmeny?: string, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerminListPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerminList(uuid, hladanyTermin, publikovany, autorPoslednejZmeny, page, size, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TerminListApi.getTerminList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TerminListApi - factory interface
 * @export
 */
export const TerminListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerminListApiFp(configuration)
    return {
        /**
         * List of Termin.
         * @param {string} uuid Primary key of entity
         * @param {string} [hladanyTermin] 
         * @param {boolean} [publikovany] 
         * @param {string} [autorPoslednejZmeny] 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerminList(uuid: string, hladanyTermin?: string, publikovany?: boolean, autorPoslednejZmeny?: string, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: any): AxiosPromise<TerminListPage> {
            return localVarFp.getTerminList(uuid, hladanyTermin, publikovany, autorPoslednejZmeny, page, size, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TerminListApi - object-oriented interface
 * @export
 * @class TerminListApi
 * @extends {BaseAPI}
 */
export class TerminListApi extends BaseAPI {
    /**
     * List of Termin.
     * @param {string} uuid Primary key of entity
     * @param {string} [hladanyTermin] 
     * @param {boolean} [publikovany] 
     * @param {string} [autorPoslednejZmeny] 
     * @param {number} [page] Page number to return, indexed from one.
     * @param {number} [size] Size of page to return.
     * @param {string} [sortBy] 
     * @param {SortDirectionEnum} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminListApi
     */
    public getTerminList(uuid: string, hladanyTermin?: string, publikovany?: boolean, autorPoslednejZmeny?: string, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig) {
        return TerminListApiFp(this.configuration).getTerminList(uuid, hladanyTermin, publikovany, autorPoslednejZmeny, page, size, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TerminPouzitieVPredpisochUpdateApi - axios parameter creator
 * @export
 */
export const TerminPouzitieVPredpisochUpdateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update pouzitie v predpisoch of termin.
         * @param {string} uuid Primary key of entity
         * @param {Array<PouzitiePredpis>} [pouzitiePredpis] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerminPouzitieVPredpisoch: async (uuid: string, pouzitiePredpis?: Array<PouzitiePredpis>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateTerminPouzitieVPredpisoch', 'uuid', uuid)
            const localVarPath = `/tezaury/terminy/{uuid}/pouzitie-v-predpisoch`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pouzitiePredpis, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerminPouzitieVPredpisochUpdateApi - functional programming interface
 * @export
 */
export const TerminPouzitieVPredpisochUpdateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerminPouzitieVPredpisochUpdateApiAxiosParamCreator(configuration)
    return {
        /**
         * Update pouzitie v predpisoch of termin.
         * @param {string} uuid Primary key of entity
         * @param {Array<PouzitiePredpis>} [pouzitiePredpis] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTerminPouzitieVPredpisoch(uuid: string, pouzitiePredpis?: Array<PouzitiePredpis>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTerminPouzitieVPredpisoch(uuid, pouzitiePredpis, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TerminPouzitieVPredpisochUpdateApi.updateTerminPouzitieVPredpisoch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TerminPouzitieVPredpisochUpdateApi - factory interface
 * @export
 */
export const TerminPouzitieVPredpisochUpdateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerminPouzitieVPredpisochUpdateApiFp(configuration)
    return {
        /**
         * Update pouzitie v predpisoch of termin.
         * @param {string} uuid Primary key of entity
         * @param {Array<PouzitiePredpis>} [pouzitiePredpis] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerminPouzitieVPredpisoch(uuid: string, pouzitiePredpis?: Array<PouzitiePredpis>, options?: any): AxiosPromise<void> {
            return localVarFp.updateTerminPouzitieVPredpisoch(uuid, pouzitiePredpis, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TerminPouzitieVPredpisochUpdateApi - object-oriented interface
 * @export
 * @class TerminPouzitieVPredpisochUpdateApi
 * @extends {BaseAPI}
 */
export class TerminPouzitieVPredpisochUpdateApi extends BaseAPI {
    /**
     * Update pouzitie v predpisoch of termin.
     * @param {string} uuid Primary key of entity
     * @param {Array<PouzitiePredpis>} [pouzitiePredpis] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminPouzitieVPredpisochUpdateApi
     */
    public updateTerminPouzitieVPredpisoch(uuid: string, pouzitiePredpis?: Array<PouzitiePredpis>, options?: RawAxiosRequestConfig) {
        return TerminPouzitieVPredpisochUpdateApiFp(this.configuration).updateTerminPouzitieVPredpisoch(uuid, pouzitiePredpis, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TerminPoznamkaUpdateApi - axios parameter creator
 * @export
 */
export const TerminPoznamkaUpdateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update poznamka of termin.
         * @param {string} uuid Primary key of entity
         * @param {UpdateTerminPoznamkaRequest} [updateTerminPoznamkaRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerminPoznamka: async (uuid: string, updateTerminPoznamkaRequest?: UpdateTerminPoznamkaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateTerminPoznamka', 'uuid', uuid)
            const localVarPath = `/tezaury/terminy/{uuid}/poznamka`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTerminPoznamkaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerminPoznamkaUpdateApi - functional programming interface
 * @export
 */
export const TerminPoznamkaUpdateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerminPoznamkaUpdateApiAxiosParamCreator(configuration)
    return {
        /**
         * Update poznamka of termin.
         * @param {string} uuid Primary key of entity
         * @param {UpdateTerminPoznamkaRequest} [updateTerminPoznamkaRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTerminPoznamka(uuid: string, updateTerminPoznamkaRequest?: UpdateTerminPoznamkaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTerminPoznamka(uuid, updateTerminPoznamkaRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TerminPoznamkaUpdateApi.updateTerminPoznamka']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TerminPoznamkaUpdateApi - factory interface
 * @export
 */
export const TerminPoznamkaUpdateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerminPoznamkaUpdateApiFp(configuration)
    return {
        /**
         * Update poznamka of termin.
         * @param {string} uuid Primary key of entity
         * @param {UpdateTerminPoznamkaRequest} [updateTerminPoznamkaRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerminPoznamka(uuid: string, updateTerminPoznamkaRequest?: UpdateTerminPoznamkaRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateTerminPoznamka(uuid, updateTerminPoznamkaRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TerminPoznamkaUpdateApi - object-oriented interface
 * @export
 * @class TerminPoznamkaUpdateApi
 * @extends {BaseAPI}
 */
export class TerminPoznamkaUpdateApi extends BaseAPI {
    /**
     * Update poznamka of termin.
     * @param {string} uuid Primary key of entity
     * @param {UpdateTerminPoznamkaRequest} [updateTerminPoznamkaRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminPoznamkaUpdateApi
     */
    public updateTerminPoznamka(uuid: string, updateTerminPoznamkaRequest?: UpdateTerminPoznamkaRequest, options?: RawAxiosRequestConfig) {
        return TerminPoznamkaUpdateApiFp(this.configuration).updateTerminPoznamka(uuid, updateTerminPoznamkaRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TerminPreviazaneTerminyUpdateApi - axios parameter creator
 * @export
 */
export const TerminPreviazaneTerminyUpdateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update previazane terminy of termin. Hard update - will replace existing terminy with terminy from requestBody
         * @param {string} uuid Primary key of entity
         * @param {PreviazaneTerminyUpdate} previazaneTerminyUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerminPreviazaneTerminy: async (uuid: string, previazaneTerminyUpdate: PreviazaneTerminyUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateTerminPreviazaneTerminy', 'uuid', uuid)
            // verify required parameter 'previazaneTerminyUpdate' is not null or undefined
            assertParamExists('updateTerminPreviazaneTerminy', 'previazaneTerminyUpdate', previazaneTerminyUpdate)
            const localVarPath = `/tezaury/terminy/{uuid}/previazane-terminy`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(previazaneTerminyUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerminPreviazaneTerminyUpdateApi - functional programming interface
 * @export
 */
export const TerminPreviazaneTerminyUpdateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerminPreviazaneTerminyUpdateApiAxiosParamCreator(configuration)
    return {
        /**
         * Update previazane terminy of termin. Hard update - will replace existing terminy with terminy from requestBody
         * @param {string} uuid Primary key of entity
         * @param {PreviazaneTerminyUpdate} previazaneTerminyUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTerminPreviazaneTerminy(uuid: string, previazaneTerminyUpdate: PreviazaneTerminyUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTerminPreviazaneTerminy(uuid, previazaneTerminyUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TerminPreviazaneTerminyUpdateApi.updateTerminPreviazaneTerminy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TerminPreviazaneTerminyUpdateApi - factory interface
 * @export
 */
export const TerminPreviazaneTerminyUpdateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerminPreviazaneTerminyUpdateApiFp(configuration)
    return {
        /**
         * Update previazane terminy of termin. Hard update - will replace existing terminy with terminy from requestBody
         * @param {string} uuid Primary key of entity
         * @param {PreviazaneTerminyUpdate} previazaneTerminyUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerminPreviazaneTerminy(uuid: string, previazaneTerminyUpdate: PreviazaneTerminyUpdate, options?: any): AxiosPromise<void> {
            return localVarFp.updateTerminPreviazaneTerminy(uuid, previazaneTerminyUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TerminPreviazaneTerminyUpdateApi - object-oriented interface
 * @export
 * @class TerminPreviazaneTerminyUpdateApi
 * @extends {BaseAPI}
 */
export class TerminPreviazaneTerminyUpdateApi extends BaseAPI {
    /**
     * Update previazane terminy of termin. Hard update - will replace existing terminy with terminy from requestBody
     * @param {string} uuid Primary key of entity
     * @param {PreviazaneTerminyUpdate} previazaneTerminyUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminPreviazaneTerminyUpdateApi
     */
    public updateTerminPreviazaneTerminy(uuid: string, previazaneTerminyUpdate: PreviazaneTerminyUpdate, options?: RawAxiosRequestConfig) {
        return TerminPreviazaneTerminyUpdateApiFp(this.configuration).updateTerminPreviazaneTerminy(uuid, previazaneTerminyUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TerminUpdateApi - axios parameter creator
 * @export
 */
export const TerminUpdateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update termin.
         * @param {string} uuid Primary key of entity
         * @param {TerminUpdate} terminUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTermin: async (uuid: string, terminUpdate: TerminUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateTermin', 'uuid', uuid)
            // verify required parameter 'terminUpdate' is not null or undefined
            assertParamExists('updateTermin', 'terminUpdate', terminUpdate)
            const localVarPath = `/tezaury/terminy/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(terminUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerminUpdateApi - functional programming interface
 * @export
 */
export const TerminUpdateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerminUpdateApiAxiosParamCreator(configuration)
    return {
        /**
         * Update termin.
         * @param {string} uuid Primary key of entity
         * @param {TerminUpdate} terminUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTermin(uuid: string, terminUpdate: TerminUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTermin(uuid, terminUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TerminUpdateApi.updateTermin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TerminUpdateApi - factory interface
 * @export
 */
export const TerminUpdateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerminUpdateApiFp(configuration)
    return {
        /**
         * Update termin.
         * @param {string} uuid Primary key of entity
         * @param {TerminUpdate} terminUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTermin(uuid: string, terminUpdate: TerminUpdate, options?: any): AxiosPromise<void> {
            return localVarFp.updateTermin(uuid, terminUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TerminUpdateApi - object-oriented interface
 * @export
 * @class TerminUpdateApi
 * @extends {BaseAPI}
 */
export class TerminUpdateApi extends BaseAPI {
    /**
     * Update termin.
     * @param {string} uuid Primary key of entity
     * @param {TerminUpdate} terminUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminUpdateApi
     */
    public updateTermin(uuid: string, terminUpdate: TerminUpdate, options?: RawAxiosRequestConfig) {
        return TerminUpdateApiFp(this.configuration).updateTermin(uuid, terminUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TerminZaznamySekcieUpdateApi - axios parameter creator
 * @export
 */
export const TerminZaznamySekcieUpdateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update zaznami sekcie of termin.
         * @param {string} uuid Primary key of entity
         * @param {Array<ZaznamSekcie>} zaznamSekcie 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerminZaznamySekcie: async (uuid: string, zaznamSekcie: Array<ZaznamSekcie>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateTerminZaznamySekcie', 'uuid', uuid)
            // verify required parameter 'zaznamSekcie' is not null or undefined
            assertParamExists('updateTerminZaznamySekcie', 'zaznamSekcie', zaznamSekcie)
            const localVarPath = `/tezaury/terminy/{uuid}/zaznamy-sekcie`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(zaznamSekcie, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerminZaznamySekcieUpdateApi - functional programming interface
 * @export
 */
export const TerminZaznamySekcieUpdateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerminZaznamySekcieUpdateApiAxiosParamCreator(configuration)
    return {
        /**
         * Update zaznami sekcie of termin.
         * @param {string} uuid Primary key of entity
         * @param {Array<ZaznamSekcie>} zaznamSekcie 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTerminZaznamySekcie(uuid: string, zaznamSekcie: Array<ZaznamSekcie>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTerminZaznamySekcie(uuid, zaznamSekcie, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TerminZaznamySekcieUpdateApi.updateTerminZaznamySekcie']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TerminZaznamySekcieUpdateApi - factory interface
 * @export
 */
export const TerminZaznamySekcieUpdateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerminZaznamySekcieUpdateApiFp(configuration)
    return {
        /**
         * Update zaznami sekcie of termin.
         * @param {string} uuid Primary key of entity
         * @param {Array<ZaznamSekcie>} zaznamSekcie 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerminZaznamySekcie(uuid: string, zaznamSekcie: Array<ZaznamSekcie>, options?: any): AxiosPromise<void> {
            return localVarFp.updateTerminZaznamySekcie(uuid, zaznamSekcie, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TerminZaznamySekcieUpdateApi - object-oriented interface
 * @export
 * @class TerminZaznamySekcieUpdateApi
 * @extends {BaseAPI}
 */
export class TerminZaznamySekcieUpdateApi extends BaseAPI {
    /**
     * Update zaznami sekcie of termin.
     * @param {string} uuid Primary key of entity
     * @param {Array<ZaznamSekcie>} zaznamSekcie 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminZaznamySekcieUpdateApi
     */
    public updateTerminZaznamySekcie(uuid: string, zaznamSekcie: Array<ZaznamSekcie>, options?: RawAxiosRequestConfig) {
        return TerminZaznamySekcieUpdateApiFp(this.configuration).updateTerminZaznamySekcie(uuid, zaznamSekcie, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TezaurusCreateApi - axios parameter creator
 * @export
 */
export const TezaurusCreateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create new tezaurus.
         * @param {TezaurusCreate} tezaurusCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTezaurus: async (tezaurusCreate: TezaurusCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tezaurusCreate' is not null or undefined
            assertParamExists('createTezaurus', 'tezaurusCreate', tezaurusCreate)
            const localVarPath = `/tezaury`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tezaurusCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TezaurusCreateApi - functional programming interface
 * @export
 */
export const TezaurusCreateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TezaurusCreateApiAxiosParamCreator(configuration)
    return {
        /**
         * Create new tezaurus.
         * @param {TezaurusCreate} tezaurusCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTezaurus(tezaurusCreate: TezaurusCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTezaurus(tezaurusCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TezaurusCreateApi.createTezaurus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TezaurusCreateApi - factory interface
 * @export
 */
export const TezaurusCreateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TezaurusCreateApiFp(configuration)
    return {
        /**
         * Create new tezaurus.
         * @param {TezaurusCreate} tezaurusCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTezaurus(tezaurusCreate: TezaurusCreate, options?: any): AxiosPromise<void> {
            return localVarFp.createTezaurus(tezaurusCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TezaurusCreateApi - object-oriented interface
 * @export
 * @class TezaurusCreateApi
 * @extends {BaseAPI}
 */
export class TezaurusCreateApi extends BaseAPI {
    /**
     * Create new tezaurus.
     * @param {TezaurusCreate} tezaurusCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TezaurusCreateApi
     */
    public createTezaurus(tezaurusCreate: TezaurusCreate, options?: RawAxiosRequestConfig) {
        return TezaurusCreateApiFp(this.configuration).createTezaurus(tezaurusCreate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TezaurusDeleteApi - axios parameter creator
 * @export
 */
export const TezaurusDeleteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete tezaurus.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTezaurus: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('deleteTezaurus', 'uuid', uuid)
            const localVarPath = `/tezaury/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TezaurusDeleteApi - functional programming interface
 * @export
 */
export const TezaurusDeleteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TezaurusDeleteApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete tezaurus.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTezaurus(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTezaurus(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TezaurusDeleteApi.deleteTezaurus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TezaurusDeleteApi - factory interface
 * @export
 */
export const TezaurusDeleteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TezaurusDeleteApiFp(configuration)
    return {
        /**
         * Delete tezaurus.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTezaurus(uuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTezaurus(uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TezaurusDeleteApi - object-oriented interface
 * @export
 * @class TezaurusDeleteApi
 * @extends {BaseAPI}
 */
export class TezaurusDeleteApi extends BaseAPI {
    /**
     * Delete tezaurus.
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TezaurusDeleteApi
     */
    public deleteTezaurus(uuid: string, options?: RawAxiosRequestConfig) {
        return TezaurusDeleteApiFp(this.configuration).deleteTezaurus(uuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TezaurusDetailApi - axios parameter creator
 * @export
 */
export const TezaurusDetailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Detail of Tezaurus.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTezaurusDetail: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getTezaurusDetail', 'uuid', uuid)
            const localVarPath = `/tezaury/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TezaurusDetailApi - functional programming interface
 * @export
 */
export const TezaurusDetailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TezaurusDetailApiAxiosParamCreator(configuration)
    return {
        /**
         * Detail of Tezaurus.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTezaurusDetail(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tezaurus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTezaurusDetail(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TezaurusDetailApi.getTezaurusDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TezaurusDetailApi - factory interface
 * @export
 */
export const TezaurusDetailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TezaurusDetailApiFp(configuration)
    return {
        /**
         * Detail of Tezaurus.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTezaurusDetail(uuid: string, options?: any): AxiosPromise<Tezaurus> {
            return localVarFp.getTezaurusDetail(uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TezaurusDetailApi - object-oriented interface
 * @export
 * @class TezaurusDetailApi
 * @extends {BaseAPI}
 */
export class TezaurusDetailApi extends BaseAPI {
    /**
     * Detail of Tezaurus.
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TezaurusDetailApi
     */
    public getTezaurusDetail(uuid: string, options?: RawAxiosRequestConfig) {
        return TezaurusDetailApiFp(this.configuration).getTezaurusDetail(uuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TezaurusListApi - axios parameter creator
 * @export
 */
export const TezaurusListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List of tezaurus.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTezaurusList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tezaury`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TezaurusListApi - functional programming interface
 * @export
 */
export const TezaurusListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TezaurusListApiAxiosParamCreator(configuration)
    return {
        /**
         * List of tezaurus.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTezaurusList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TezaurusList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTezaurusList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TezaurusListApi.getTezaurusList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TezaurusListApi - factory interface
 * @export
 */
export const TezaurusListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TezaurusListApiFp(configuration)
    return {
        /**
         * List of tezaurus.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTezaurusList(options?: any): AxiosPromise<TezaurusList> {
            return localVarFp.getTezaurusList(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TezaurusListApi - object-oriented interface
 * @export
 * @class TezaurusListApi
 * @extends {BaseAPI}
 */
export class TezaurusListApi extends BaseAPI {
    /**
     * List of tezaurus.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TezaurusListApi
     */
    public getTezaurusList(options?: RawAxiosRequestConfig) {
        return TezaurusListApiFp(this.configuration).getTezaurusList(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TezaurusUpdateApi - axios parameter creator
 * @export
 */
export const TezaurusUpdateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update tezaurus.
         * @param {Tezaurus} tezaurus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTezaurus: async (tezaurus: Tezaurus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tezaurus' is not null or undefined
            assertParamExists('updateTezaurus', 'tezaurus', tezaurus)
            const localVarPath = `/tezaury`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tezaurus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TezaurusUpdateApi - functional programming interface
 * @export
 */
export const TezaurusUpdateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TezaurusUpdateApiAxiosParamCreator(configuration)
    return {
        /**
         * Update tezaurus.
         * @param {Tezaurus} tezaurus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTezaurus(tezaurus: Tezaurus, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTezaurus(tezaurus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TezaurusUpdateApi.updateTezaurus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TezaurusUpdateApi - factory interface
 * @export
 */
export const TezaurusUpdateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TezaurusUpdateApiFp(configuration)
    return {
        /**
         * Update tezaurus.
         * @param {Tezaurus} tezaurus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTezaurus(tezaurus: Tezaurus, options?: any): AxiosPromise<void> {
            return localVarFp.updateTezaurus(tezaurus, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TezaurusUpdateApi - object-oriented interface
 * @export
 * @class TezaurusUpdateApi
 * @extends {BaseAPI}
 */
export class TezaurusUpdateApi extends BaseAPI {
    /**
     * Update tezaurus.
     * @param {Tezaurus} tezaurus 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TezaurusUpdateApi
     */
    public updateTezaurus(tezaurus: Tezaurus, options?: RawAxiosRequestConfig) {
        return TezaurusUpdateApiFp(this.configuration).updateTezaurus(tezaurus, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get current logged user with defined roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/aktualny-pouzivatel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * Get current logged user with defined roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * Get current logged user with defined roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options?: any): AxiosPromise<UserDetail> {
            return localVarFp.getCurrentUser(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * Get current logged user with defined roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getCurrentUser(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }
}



